export enum businessTypeEnum {
  individual = 'individual',
  establishment = 'establishment',
  corporate = 'corporate',
  ngo = 'ngo',
}
